var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.isAudit
                    ? [
                        _vm.pendingAudit
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.onPass },
                              },
                              [_vm._v(_vm._s(_vm.$t("goodsAudit.detail.Pass")))]
                            )
                          : _vm._e(),
                        _vm.pendingAudit
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "warning" },
                                on: { click: _vm.onReject },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("goodsAudit.detail.Reject"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.cancel } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                  _c("BjLogButton", {
                    attrs: {
                      id: _vm.data.id,
                      permission: "BusinessGoodsAuditSkuPackage_Log",
                      title: _vm.data.name,
                      api: "goodsApi",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("span")]
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: [{}],
            border: "",
            "show-header": false,
            "cell-style": _vm.handleCellStyle(),
          },
        },
        [
          _c("el-table-column", { attrs: { width: _vm.labelWidth } }),
          _c(
            "el-table-column",
            { attrs: { prop: "value", align: "center" } },
            [
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.data.draftSkuVO
                        ? _vm.$t("goodsAudit.detail.BeforeModification")
                        : _vm.$t("goodsAudit.detail.ProductDetails")
                    )
                  ),
                ]),
              ],
            ],
            2
          ),
          _vm.data.draftSkuVO
            ? _c(
                "el-table-column",
                { attrs: { prop: "newValue", align: "center" } },
                [
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("goodsAudit.detail.AfterModification"))
                      ),
                    ]),
                  ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("goodsAudit.detail.BasicInformation"))),
      ]),
      _vm.setFlag === 0
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.baseAttribute,
                border: "",
                "show-header": false,
                "cell-style": _vm.handleCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", width: _vm.labelWidth },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "link",
                              attrs: {
                                type: _vm.checkData(scope.row) ? _vm.color : "",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("goodsPage." + scope.row.key))
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  729170675
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "value", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.key === "asignBarcode"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "discontinued"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "seasonable"
                            ? _c("span", [_vm._v(" All Seasonable")])
                            : row.key === "fragile"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "needExpired"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "purchaseItem"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "salesItem"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "inventoryItem"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "dangerousGoods"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "flammable"
                            ? _c(
                                "span",
                                [
                                  _c("el-switch", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.value,
                                      callback: function ($$v) {
                                        _vm.$set(row, "value", $$v)
                                      },
                                      expression: "row.value",
                                    },
                                  }),
                                ],
                                1
                              )
                            : row.key === "imageUrl"
                            ? _c(
                                "span",
                                { staticClass: "flex-center" },
                                [
                                  row.value
                                    ? _c("BjKeyImage", {
                                        staticClass: "avatar",
                                        attrs: {
                                          url: row.value,
                                          preview: "",
                                          fit: "cover",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                {
                                  attrs: {
                                    type: _vm.checkData(row) ? _vm.color : "",
                                    underline: false,
                                  },
                                },
                                [_vm._v(_vm._s(row.value) + " ")]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3711863150
                ),
              }),
              _vm.data.draftSkuVO
                ? _c("el-table-column", {
                    attrs: { prop: "newValue", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.key === "asignBarcode"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "discontinued"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "seasonable"
                                ? _c("span", [_vm._v(" All Seasonable")])
                                : row.key === "fragile"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "needExpired"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "purchaseItem"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "salesItem"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "inventoryItem"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "dangerousGoods"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "flammable"
                                ? _c(
                                    "span",
                                    [
                                      _c("el-switch", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: row.newValue,
                                          callback: function ($$v) {
                                            _vm.$set(row, "newValue", $$v)
                                          },
                                          expression: "row.newValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : row.key === "imageUrl"
                                ? _c(
                                    "span",
                                    { staticClass: "flex-center" },
                                    [
                                      row.newValue
                                        ? _c("BjKeyImage", {
                                            staticClass: "avatar",
                                            attrs: {
                                              url: row.newValue,
                                              preview: "",
                                              fit: "cover",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    {
                                      attrs: {
                                        type: _vm.checkData(row)
                                          ? _vm.color
                                          : "",
                                        underline: false,
                                      },
                                    },
                                    [_vm._v(_vm._s(row.newValue) + " ")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      227456270
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.setFlag === 1
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.skuPackageAttributeList,
                border: "",
                "show-header": false,
                "cell-style": _vm.handleCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", width: _vm.labelWidth },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "link",
                              attrs: {
                                type: _vm.checkData(scope.row) ? _vm.color : "",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("goodsPage." + scope.row.key))
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  729170675
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "value", align: "center" },
              }),
              _vm.data.draftSkuVO
                ? _c("el-table-column", {
                    attrs: { prop: "newValue", align: "center" },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.setFlag === 0
        ? _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("goodsAudit.detail.attribute"))),
          ])
        : _vm._e(),
      _vm.setFlag === 0
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.newSkuAttribute,
                border: "",
                "show-header": false,
                "cell-style": _vm.handleCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", width: _vm.labelWidth },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              attrs: {
                                type: _vm.checkData(row) ? _vm.color : "",
                                underline: false,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("goodsSku.detail." + row.key)) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2897057042
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "value", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.key === "UnitVolume"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.data.thisSkuVO &&
                                      (_vm.data.thisSkuVO["width"] *
                                        _vm.data.thisSkuVO.length *
                                        _vm.data.thisSkuVO.height) /
                                        1000000
                                  ) + "m³"
                                ),
                              ])
                            : row.key === "Volume"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.data.thisSkuVO &&
                                      (_vm.data.thisSkuVO["cartonWidth"] *
                                        _vm.data.thisSkuVO.cartonLength *
                                        _vm.data.thisSkuVO.cartonHeight) /
                                        1000000
                                  ) + "m³"
                                ),
                              ])
                            : _c(
                                "span",
                                {
                                  attrs: {
                                    type: _vm.checkData(row) ? _vm.color : "",
                                    underline: false,
                                  },
                                },
                                [_vm._v(_vm._s(row.value))]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1176869904
                ),
              }),
              _vm.data.draftSkuVO
                ? _c("el-table-column", {
                    attrs: { prop: "newValue", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.key === "UnitVolume"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.data.draftSkuVO &&
                                          (_vm.data.draftSkuVO["width"] *
                                            _vm.data.draftSkuVO.length *
                                            _vm.data.draftSkuVO.height) /
                                            1000000
                                      ) + "m³"
                                    ),
                                  ])
                                : _vm._e(),
                              row.key === "Volume"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.data.draftSkuVO &&
                                          (_vm.data.draftSkuVO["cartonWidth"] *
                                            _vm.data.draftSkuVO.cartonLength *
                                            _vm.data.draftSkuVO.cartonHeight) /
                                            1000000
                                      ) + "m³"
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    type: _vm.checkData(row) ? _vm.color : "",
                                    underline: false,
                                  },
                                },
                                [_vm._v(_vm._s(row.newValue) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3454070663
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.setFlag === 1
        ? _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("goodsAudit.detail.packageSku"))),
          ])
        : _vm._e(),
      _vm.setFlag === 1
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.skuDetailList,
                border: "",
                "show-header": false,
                "cell-style": _vm.handleCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", width: _vm.labelWidth },
              }),
              _c("el-table-column", {
                attrs: { prop: "value", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.value) + " "),
                          _c(
                            "span",
                            {
                              staticClass: "link ml10",
                              on: {
                                click: function ($event) {
                                  return _vm.onSkuDetail(scope.row.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("detailsText")))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  569023224
                ),
              }),
              _vm.data.draftSkuVO
                ? _c("el-table-column", {
                    attrs: { prop: "newValue", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.row.newValue) + " "),
                              _c(
                                "span",
                                {
                                  staticClass: "link ml10",
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSkuDetail(scope.row.newRow)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("detailsText")))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      635563512
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("table.auditText")))]),
      _c(
        "el-form",
        [
          !_vm.pendingAudit
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("goodsAudit.detail.status") },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  _vm.GOODS_AUDIT_STATUS_LIST.bjGet(
                                    _vm.$route.query.status
                                  )
                                )
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("goodsAudit.detail.comments"),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.data.thisSkuVO &&
                                  _vm.data.thisSkuVO.auditIdea
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("DialogIdea", { ref: "DialogIdea", on: { confirm: _vm.onConfirm } }),
      _c("RowDetailFromSkuDetailList", {
        ref: "RowDetailFromSkuDetailList",
        attrs: {
          cols: _vm.skuDetailTableColumns,
          "handle-cell-style": _vm.handleCellStyle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }